import * as React from 'react';

export default function SVGCaretLeft(): JSX.Element {
  return (
    <svg
      width="11"
      height="19"
      viewBox="0 0 11 19"
      fill="none"
      className="text-textTertiary stroke-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m9.631 1.521-8.05 8.021 8.05 7.98" strokeWidth={2} strokeLinecap="round" />
    </svg>
  );
}
